import { useTheme, type ThemeChoice } from "../hooks/useTheme";
import styles from "./ThemeToggle.module.css";

/** Cycle order and the glyph + words shown for each choice. */
const CYCLE: ThemeChoice[] = ["system", "light", "dark"];
const GLYPH: Record<ThemeChoice, string> = {
  system: "◐",
  light: "☀",
  dark: "☾",
};
const WORD: Record<ThemeChoice, string> = {
  system: "system",
  light: "light",
  dark: "dark",
};

/**
 * Three-state theme switch (System -> Light -> Dark -> System). Lives in the
 * shared TopBar so it appears on every app + marketing surface. Styled with
 * tokens, so it themes itself.
 */
export function ThemeToggle() {
  const { choice, setTheme } = useTheme();

  function next() {
    const i = CYCLE.indexOf(choice);
    setTheme(CYCLE[(i + 1) % CYCLE.length] ?? "system");
  }

  return (
    <button
      type="button"
      className={styles.toggle}
      onClick={next}
      aria-label={`Theme: ${WORD[choice]} (click to switch)`}
      title={`Theme: ${WORD[choice]}`}
    >
      <span aria-hidden="true">{GLYPH[choice]}</span>
    </button>
  );
}
